import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * This utility:
 *   - Filters out falsy values (false, null, undefined, 0, '')
 *   - Flattens arrays of classes
 *   - Supports conditional objects for toggling classes
 *   - Merges Tailwind classes, resolving conflicting utilities
 *
 * Usage example:
 *   const isPrimary = true;
 *   const isDisabled = false;
 *   const className = cn(
 *     "button",
 *     isPrimary && "button-primary",
 *     isDisabled && "opacity-50",
 *     ["p-2", "rounded"]
 *   );
 *   // Result (when isPrimary=true, isDisabled=false):
 *   // "button button-primary p-2 rounded"
 *   // Result (when isPrimary=false, isDisabled=true):
 *   // "button opacity-50 p-2 rounded"
 *
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
